import { Input } from "antd";
import { useContext, useEffect, useState } from "react";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { MPagination } from "../../../../helper/pagination";
import { RouteContext } from "../../user/screen/components/route.context";
import { Product, ProductInquiry } from "../entity/product.model";
import { productService } from "../service/product.service";
import ProductTable from "./component/ProductTable";

function Products() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [productPagination, setProductPagination] = useState<
    MPagination<Product>
  >({ count: 1, results: [] });
  const [name, setName] = useState("");
  const [article, setArticle] = useState("");

  const pageChange = (inquiry: ProductInquiry) => {
    dispatch({ type: spinActions.BLOCK });

    inquiry.name = name;
    inquiry.article = article;
    inquiry.routeId = state.routeId;

    productService
      .getProducts(inquiry)
      .then((pagination: MPagination<Product>) => {
        productPagination.current = inquiry.page;
        setProductPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };
  useEffect(() => {
    let inquiry: ProductInquiry = { page: 1, pageSize: 10 };
    pageChange(inquiry);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const onSubmit = (e: any) => {
    e.preventDefault();

    pageChange({
      page: 1,
      pageSize: 10,
    });
  };

  return (
    <>
      <MPageHeader crumbs={["Бүтээгдэхүүнүүд"]} />

      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Бүтээгдэхүүнүүд</h6>
          </div>
          <div className="card-body">
            <div className="mb-2">
              <form onSubmit={onSubmit}>
                <Input
                  allowClear
                  style={{ width: "236px" }}
                  value={name}
                  placeholder="Нэрийг оруулна уу"
                  onChange={(e) => setName(e.target.value)}
                />
                <Input
                  allowClear
                  className="ml-2"
                  style={{ width: "236px" }}
                  value={article}
                  placeholder="Бар кодыг оруулна уу"
                  onChange={(e) => setArticle(e.target.value)}
                />
                <button type="submit" className="btn btn-sm btn-primary ml-2">
                  <i className="icon-search4 mr-2" />
                  Хайх
                </button>
              </form>
            </div>
            <ProductTable
              onChange={(page: number, pageSize: number) => {
                pageChange({ page, pageSize });
              }}
              pagination={productPagination}
            ></ProductTable>
          </div>
        </div>
      </div>
    </>
  );
}

export default Products;
